import { FC, PropsWithChildren, useContext } from 'react';

import PrivateContext from 'src/routes/Private/PrivateContext';

import SideNavigation from './SideNavigation';
import { AppBarSpacer, Container, Content, LoadingProgress } from './styles';
import TopNavigation from './TopNavigation';

const PrivateLayout: FC<PropsWithChildren> = ({ children }) => {
  const { sideMenuIsOpen, layoutLoading } = useContext(PrivateContext);

  return (
    <Container>
      <TopNavigation />
      <SideNavigation />
      <Content isOpen={sideMenuIsOpen}>
        <AppBarSpacer>{layoutLoading && <LoadingProgress />}</AppBarSpacer>
        {children}
      </Content>
    </Container>
  );
};

export default PrivateLayout;
